module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_SkipToStart_16"],"path":[{"$":{"d":"M2,3H4V13H2ZM14,13V3L5,8Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_SkipToStart_16.svg
// module id = 3GXI
// module chunks = 1